import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Blog from "../pages/blog/page";
import BlogPost from '../pages/blog-post/page';
import AuthorPage from '../pages/author/page';
import CategoriesPage from '../pages/categories/page';
import CategoryPage from '../pages/category/page';
import ContactPage from '../pages/contact/page';
import PageSingle from '../pages/PageSingle';
import About from '../pages/About';
import CryptoExchangesPage from '../pages/crypto-exchanges/CryptoExchanges';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPost />,
  },
  {
    path: '/author/:authorSlug',
    element: <AuthorPage />,
  },
  {
    path: '/categories',
    element: <CategoriesPage />
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/:slug",
    element: <PageSingle />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/crypto-exchanges",
    element: <CryptoExchangesPage />,
  },
];

export default routes;
